import React from 'react';
import SessionEmotionData from '../../../../containers/sessionDetails/sessionEmotionData';

export const SurveyEmotions = props => {
  return <SessionEmotionData sessionId={props.sessionId} surveyId={props.surveyId} sessionName={props.sessionName} />;
};
